import { Link } from "react-router-dom";
import { DEPARTMENTS } from "@/lib/departments";

// Department image tiles -> filtered catalogue (/category/hardware?dept=<slug>).
export default function ShopByDepartment() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="shop-by-department">
      <div className="mb-6">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Shop by Department</h2>
        <p className="text-muted-foreground text-sm mt-1">Every aisle of the hardware store — now online.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {DEPARTMENTS.map((d) => (
          <Link
            key={d.slug}
            to={`/category/hardware?dept=${d.slug}`}
            data-testid={`department-tile-${d.slug}`}
            className="group relative overflow-hidden rounded-2xl border border-border bg-card sn-card-hover"
          >
            <div className="aspect-square overflow-hidden bg-slate-100">
              <img
                src={d.img}
                alt={d.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-3">
              <div className="font-display font-bold text-sm leading-snug text-ink group-hover:text-emerald transition-colors">{d.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
